import { motion } from "framer-motion";
import { Plus } from "lucide-react";

export default function ProductCard({ product, index = 0, onQuickView }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.55, delay: (index % 4) * 0.07, ease: [0.22, 1, 0.36, 1] }}
      className="group bg-[#111114] border border-white/[0.08] hover:border-[#D3FF24]/50 transition-colors duration-300 hover:-translate-y-1 will-change-transform"
      data-testid={`product-card-${product.id}`}
    >
      <button
        data-testid={`product-quickview-${product.id}`}
        onClick={() => onQuickView(product)}
        className="relative block w-full text-left overflow-hidden"
      >
        <div className="aspect-[3/4] overflow-hidden">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        {product.badge && (
          <span className="absolute top-3 left-3 bg-[#D3FF24] text-[#0A0A0C] text-[9px] font-bold tracking-[0.2em] px-2.5 py-1">
            {product.badge}
          </span>
        )}
        <span className="absolute bottom-3 right-3 flex items-center gap-1.5 bg-[#0A0A0C]/85 backdrop-blur text-white text-[10px] font-bold tracking-[0.2em] px-3 py-2 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
          <Plus className="h-3.5 w-3.5 text-[#D3FF24]" /> QUICK VIEW
        </span>
      </button>
      <div className="p-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-display font-bold text-sm tracking-wide leading-tight">{product.name}</h3>
          <p className="text-[10px] tracking-[0.2em] text-white/40 mt-1.5 uppercase">
            {product.category} — {product.subcategory}
          </p>
        </div>
        <span className="font-display font-extrabold text-sm text-[#D3FF24] whitespace-nowrap">
          ${product.price.toFixed(2)}
        </span>
      </div>
    </motion.article>
  );
}
